import styled from 'styled-components';

const InfantSelect = styled.select`
  width: 100%;
  min-height: 25px;
  outline: none;
  border-style: solid;
  border-width: 1px;
  border-color: grey;
`;

export { InfantSelect };
